import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading, VerifiedBadge } from '../../components';

import css from './SectionTitleBar.module.css';

const StarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  </svg>
);

/**
 * Airbnb-style listing title bar.
 *
 * Props:
 *   - title: string
 *   - location: string (city / full address)
 *   - locationHref: string – anchor href for the address link (e.g. "#listing-location-full")
 *   - rating: number
 *   - reviewCount: number
 *   - isVerifiedProvider: boolean – zeigt das Vertrauens-Badge in der Metazeile
 */
const SectionTitleBar = props => {
  const { title, location, locationHref, rating, reviewCount, isVerifiedProvider } = props;

  const hasRating = typeof rating === 'number' && rating > 0;
  const hasReviews = typeof reviewCount === 'number' && reviewCount > 0;
  const hasMeta = hasRating || hasReviews || !!location || isVerifiedProvider;

  return (
    <section className={css.root}>
      <Heading as="h1" rootClassName={css.title}>
        {title}
      </Heading>

      {hasMeta ? (
        <div className={css.meta}>
          {hasRating ? (
            <span className={css.rating}>
              <StarIcon />
              <span className={css.ratingValue}>{rating.toFixed(2)}</span>
            </span>
          ) : null}
          {hasReviews ? (
            <>
              {hasRating ? <span className={css.dot}>·</span> : null}
              <span className={css.reviewCount}>
                <FormattedMessage id="ListingPage.reviewCount" values={{ count: reviewCount }} />
              </span>
            </>
          ) : null}
          {location ? (
            <>
              {hasRating || hasReviews ? <span className={css.dot}>·</span> : null}
              {locationHref ? (
                <a href={locationHref} className={css.location}>
                  {location}
                </a>
              ) : (
                <span className={css.location}>{location}</span>
              )}
            </>
          ) : null}
          {/* Bewusst in der Metazeile MIT sichtbarem Wort, nicht als blosses
              Zeichen an der H1: neben dem Namen des Raums gelesen wuerde ein
              Haken zur Aussage "dieser Space ist geprueft" — und geprueft sind
              Identitaet und Auszahlungskonto des ANBIETERS, mehr nicht. */}
          {isVerifiedProvider ? (
            <>
              {hasRating || hasReviews || location ? <span className={css.dot}>·</span> : null}
              <VerifiedBadge size="medium" withTooltip showLabel placement="listing_title" />
            </>
          ) : null}
        </div>
      ) : null}
    </section>
  );
};

export default SectionTitleBar;
